import {
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAIL,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_FAIL,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAIL,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAIL,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAIL,
  SET_ACCOUNT_LOADING,
  CLEAR_ACCOUNT_ERROR,
  GET_VALIDATORS_SUCCESS,
  GET_VALIDATORS_FAIL,
} from '../reducers/types';
import axios from 'axios';

import { returnError, tokenConfig } from './actionHelperFunc';
const acUrl = '/api/account';

// USER RELATED ACTIONS
export const addAccount = (newAc) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_ACCOUNT_ERROR });
    dispatch({ type: SET_ACCOUNT_LOADING });

    const { data } = await axios.post(
      `${acUrl}/addAccount`,
      newAc,
      tokenConfig(getState)
    );

    dispatch({
      type: ADD_ACCOUNT_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({ type: ADD_ACCOUNT_FAIL, payload: returnError(error) });
  }
};

export const getAccountById = (accountId) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ACCOUNT_LOADING });
    dispatch({ type: CLEAR_ACCOUNT_ERROR });

    const { data } = await axios.get(
      `${acUrl}/getById?accountId=${accountId}`,
      tokenConfig(getState)
    );
    dispatch({
      type: GET_ACCOUNT_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({ type: GET_ACCOUNT_FAIL, payload: returnError(error) });
  }
};

export const getAccount = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_ACCOUNT_ERROR });
    dispatch({ type: SET_ACCOUNT_LOADING });

    const { data } = await axios.get(`${acUrl}`, tokenConfig(getState));
    dispatch({
      type: GET_ACCOUNT_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({ type: GET_ACCOUNT_FAIL, payload: returnError(error) });
  }
};

export const getAllAccountsByProject =
  (projectId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_ACCOUNT_ERROR });
      dispatch({ type: SET_ACCOUNT_LOADING });

      const { data } = await axios.get(
        `${acUrl}/accountDashboard?projectId=${projectId}`,
        tokenConfig(getState)
      );

      dispatch({
        type: GET_ACCOUNTS_SUCCESS,
        payload: data.data,
      });
    } catch (error) {
      dispatch({ type: GET_ACCOUNTS_FAIL, payload: returnError(error) });
    }
  };

export const updateAccount = (ac) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_ACCOUNT_ERROR });
    dispatch({ type: SET_ACCOUNT_LOADING });

    const config = tokenConfig(getState);

    const { data } = await axios.post(`${acUrl}/editAccount`, ac, config);
    dispatch({ type: UPDATE_ACCOUNT_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: UPDATE_ACCOUNT_FAIL, payload: returnError(error) });
  }
};

export const deleteAccount = (accountId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_ACCOUNT_ERROR });
    dispatch({ type: SET_ACCOUNT_LOADING });

    const config = tokenConfig(getState);

    const { data } = await axios.delete(`${acUrl}/delete/${accountId}`, config);
    dispatch({ type: DELETE_ACCOUNT_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: DELETE_ACCOUNT_FAIL, payload: returnError(error) });
  }
};

export const getAllValidatorsProject =
  (projectId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_ACCOUNT_ERROR });
      dispatch({ type: SET_ACCOUNT_LOADING });

      const { data } = await axios.post(
        `${acUrl}/getValidatorData`,
        { projectId },
        tokenConfig(getState)
      );

      dispatch({
        type: GET_VALIDATORS_SUCCESS,
        payload: data.data,
      });
    } catch (error) {
      dispatch({ type: GET_VALIDATORS_FAIL, payload: returnError(error) });
    }
  };
